import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { HarmonyAddress } from 'app/shared/model/harmony-address';
import { map } from 'rxjs/operators';
import { LogService } from './log.service';

@Injectable()
export class RapidAddressService {

  constructor(
    private http: HttpClient,
    private logService: LogService
  ) { }

  addressSearch(partialAddress: string): Observable<HarmonyAddress[]> {
    // Address lookups go through our own backend, which holds the Mastersoft
    // credential and calls Harmony server-side. This keeps the credential out of
    // the client bundle and avoids Mastersoft's per-domain referer allowlist.
    const url = `${environment.functionsURL}/addressSearch`;
    this.logService.log('Calling ' + url);
    return this.http.post(url, { partialAddress }).pipe(
      map(res => (res as any).addresses as HarmonyAddress[])
    );
  }


}
